import { useEffect, useState } from "react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

/**
 * Confirm removing a user from one of their coached groups.
 * `user` must include `name` and `groups: [{ id, name, membershipId }]`.
 */
export function CoachRemoveUserDialog({ user, onCancel, onConfirm }) {
  const [membershipId, setMembershipId] = useState(null)

  useEffect(() => {
    if (user?.groups?.length) {
      setMembershipId(user.groups[0].membershipId)
    } else {
      setMembershipId(null)
    }
  }, [user])

  const open = !!user
  const groups = user?.groups || []
  const selectedGroup = groups.find((g) => g.membershipId === membershipId)
  const groupName = selectedGroup?.name ?? "this group"

  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel() }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Remove {user?.name ?? "member"} from a group?
          </AlertDialogTitle>
          <AlertDialogDescription>
            They are only removed from the group you choose. Their account stays active,
            and they remain in any other groups until you remove them there too.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {groups.length > 1 && (
          <div className="space-y-2">
            <Label>Remove from</Label>
            <Select
              value={membershipId != null ? String(membershipId) : ""}
              onValueChange={(v) => setMembershipId(Number(v))}
            >
              <SelectTrigger>
                <SelectValue placeholder="Choose group" />
              </SelectTrigger>
              <SelectContent>
                {groups.map((g) => (
                  <SelectItem key={g.membershipId} value={String(g.membershipId)}>
                    {g.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-red-600 hover:bg-red-700 text-white"
            disabled={membershipId == null}
            onClick={() => membershipId != null && onConfirm(membershipId)}
          >
            Remove from {groupName}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
